import React from "react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { Fab, Card, InputAdornment } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import api from "../../../components/services/api";
import SearchData from "../components/SearchData";
import TextField from "@mui/material/TextField";
import DowloadBT from "../components/dowloadBT";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import SearchIcon from "@mui/icons-material/Search";
import { useSelector } from "react-redux";
import { saveAs } from "file-saver";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import moment from "moment";
import {
  GridToolbarContainer,
  GridToolbarExport,
  gridClasses,
} from "@mui/x-data-grid";
import mime from "mime";
import DownloadIcon from '@mui/icons-material/Download';
import useDebounce from "../../../libs/hooks/useDebounce";
export default function SaleOrder() {
  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);

  const [checkAll, setCheckAll] = useState(true);
  const [key, setKey] = useState('')
  const debouncedKey = useDebounce(key, 500);
  const [loading, setLoading] = useState(false)

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);
  const [gridLoading, setGridLoading] = useState(false);

  const [dataFilter, setDataFilter] = useState([]);
  const MenuActive = useSelector((state) => state.MenuActive.List);
  function CustomToolbar() {
    return (
      <GridToolbarContainer className={gridClasses.toolbarContainer}>
        <Button
          size="small"
          style={{
            color: "#84BD5A",
            borderColor: "#84BD5A",
            border: "1px solid #84BD5A",
          }}
          onClick={async () => {
            await api
              .get(`api/report/SaleOrder/download`, {
                responseType: "blob",
                timeout: 3000,
              })
              .then((blobFile) => {
                const blobFileRes = new File(
                  [blobFile?.data],
                  "test.pdf",
                  {
                    type: mime.getType(".xlsx"),
                  }
                );

                // window.open(
                //   URL.createObjectURL(blobFileRes, "test.csv"),
                //   "_blank"
                // );
                saveAs(blobFileRes, "Reportquotation.xlsx");

              });
          }}
        ><SaveAltIcon sx={{ fontSize: "20px", marginRight: '5px' }} />
          Export
        </Button>
      </GridToolbarContainer>
    );
  }
  /* table data */
  const columns = [
    { field: "SaleOrderNo", headerName: "SO NO.", width: 150 },
    { field: "Quantity", headerName: "Volume.", width: 120 },
    //
    //   { field: "ShippingBookingNo", headerName: "ShipperRefNo.", width: 150 },

    { field: "CustomerName", headerName: "CUSTOMER", width: 180 },
    {
      field: "ETDPOLDate",
      headerName: "ETD POL",
      width: 150,
      valueFormatter: ({ value }) => {
        return moment(value).format("DD-MM-YYYY");
      },
    },
    {
      field: "ClosingDate",
      headerName: "CLOSINGDATE",
      width: 150,
      valueFormatter: ({ value }) => {
        return moment(value).format("DD-MM-YYYY");
      },
    },
    {
      field: "FirstLadenDate",
      headerName: "ReturnContainer.",
      width: 150,
      valueFormatter: ({ value }) => {
        return moment(value).format("DD-MM-YYYY");
      },
    },
    { field: "ShipperRefNo", headerName: "ShipperRefNo.", width: 150 },
    { field: "BookingNo", headerName: "BOOKING NO.", width: 150 },
    { field: "TerminalName", headerName: "TerminalName", width: 150 },
    {
      field: "SaleOrderStatus",
      headerName: "STATUS",
      width: 150,
      valueFormatter: ({ value }) =>
        value == 1
          ? "New"
          : value == 2
            ? "Processing"
            : value == 3
              ? "AssignToPlanner"
              : value == 4
                ? "AssignToCy"
                : value == 5
                  ? "Confirm"
                  : value == 6
                    ? "AssigntoDocument"
                    : value == 7
                      ? "AssigntoAdmin"
                      : value == 8
                        ? "Complete"
                        : "Cancle",
    },
    { field: "ShipperInvoiceNo", headerName: "INV NO.", width: 180 },
    {
      field: "Action",
      width: 200,
      sortable: false,
      headerClassName: 'sticky',
      renderCell: (params) => {
        return (
          <>
            <Link
              to={{
                pathname: `/CustomerSupport/EditSaleOrder/${params.id}`,
              }}
            >
              <Button
                variant="contained"
                style={{ textTransform: "none", backgroundColor: "#007BFF", marginRight:'10px' }}
              >
                View
              </Button>
            </Link>
            <Link
              to={{
                pathname: `/CustomerSupport/DuplicateSaleOrder/${params.id}`,
              }}
            >
              <Button
                variant="contained"
                style={{ textTransform: "none", backgroundColor: "#007BFF" }}
              >
                Duplicate 
              </Button>
            </Link>
          </>
        );
      },
    },
  ];

  //fetch Data
  const getData = async () => {
    setGridLoading(true);
    try {
      const params = new URLSearchParams();
      params.append('page', page + 1);
      params.append('limit', pageSize);
      if (debouncedKey) params.append('keyword', debouncedKey);
      if (dateStart) params.append('startDate', moment(dateStart).format('yyyy-MM-DD'));
      if (dateEnd) params.append('endDate', moment(dateEnd).format('yyyy-MM-DD'));

      const res = await api.get(`api/saleorder/list-paginated?${params.toString()}`);
      setDataFilter(res.data?.data || []);
      setRowCount(res.data?.total || 0);
    } catch (e) {
      console.log(e);
    } finally {
      setGridLoading(false);
    }
  };

  useEffect(() => {
    setPage(0);
  }, [debouncedKey, dateStart, dateEnd]);

  //api call
  useEffect(() => {
    getData();
  }, [debouncedKey, dateStart, dateEnd, page, pageSize]);
  const download = async () => {
    setLoading(true)
    await api.get(`api/report/saleorder/download?keyword=${debouncedKey}${dateStart ? '&startDate=' + moment(dateStart).format('yyyy-MM-DD') : ''}${dateEnd ? '&endDate=' + moment(dateEnd).format('yyyy-MM-DD') : ''}`, {
      responseType: "blob",
      timeout: 30000
    })
      .then((blobFile) => {
        const blobFileRes = new File([blobFile?.data], "test.xlsx", {
          type: mime.getType(".xlsx"),

        });

        // window.open(
        //   URL.createObjectURL(blobFileRes, "test.csv"),
        //   "_blank"
        // );
        saveAs(blobFileRes, "saleorder-report.xlsx");
        setLoading(false)
      }).catch((errpr) => {
        setLoading(false)})
  }
  //Floating Button
  const floating_action_style = {
    margin: 0,
    top: "auto",
    right: 20,
    bottom: 10,
    left: "auto",
    position: "fixed",
  };
  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
          <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
            ลูกค้า
          </h6>

          <Grid container alignItems="center" spacing={1}>
            <Grid item xs>
              <Typography
                className="textcolordarkblue"
                variant="h5"
                component="h1"
              >
                Sale Order
              </Typography>
            </Grid>
            <Grid item sx={{ display: "flex", flexDirection: "row" }}>
              <Typography className="textcolorBule">
                Customer Support
              </Typography>
              <Typography>
                <span>&nbsp;</span> / Sale Order
              </Typography>
            </Grid>
          </Grid>

          <Grid
            style={{ marginTop: "10px", display: "flex", flexDirection: "row", justifyContent: "space-between", }}
          >
            <div style={{ display: "flex" }}>
              <DesktopDatePicker
                label="Date Start"
                value={dateStart}
                inputFormat="dd-MM-yyyy"
                minDate={new Date("2017-01-01")}
                onChange={(newValue) => {
                  setDateStart(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    size="small"
                    style={{ width: "60%" }} {...params} />
                )}
              />
              <DesktopDatePicker
                label="Date End"
                inputFormat="dd-MM-yyyy"
                value={dateEnd}
                minDate={new Date(dateStart)}
                onChange={(newValue) => {
                  setDateEnd(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    size="small"
                    style={{ width: "60%", marginLeft: "10px" }}
                    {...params}
                  />
                )}
              />
            </div>
            <div style={{ display: "flex" }}>

              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                  disableUnderline: true,
                }}
                label="Search"
                onChange={(e) => setKey(e.target.value)}
                size="small"
              />
              <Button variant="outlined" disabled={loading}
                style={{ color: "#84BD5A", borderColor: "#84BD5A", marginLeft: '10px' }} onClick={() => download()}>
                <span className="material-icons-outlined">description</span>
                {loading ? 'Loading...' : 'Export'}</Button>
            </div>
          </Grid>

          <Box
            sx={{
              height: 630,
              width: "100%",
              marginTop: "10px",
              position: "relative",
              "& .Complete": {
                color: "#28A745",
              },
              "& .New": {
                color: "#007BFF",
              },
              "& .Process": {
                color: "#F39C12",
              },
              "& .AssignToPlanner": {
                color: "#F39C12",
              },
              "& .AssignToCy": {
                color: "#F39C12",
              },
              "& .AssignToCs": {
                color: "#F39C12",
              },
              "& .AssignToDocument": {
                color: "#F39C12",
              },
              '& .MuiDataGrid-cell--withRenderer': {
                width: '100%',
                backgroundColor: "#fff",
                position: "sticky",
                right: '0'
              },
              '& .MuiTablePagination-root': {
                overflow: 'visible',
              },
              '& .MuiTablePagination-toolbar': {
                minHeight: 40,
                alignItems: 'center',
              },
              '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                margin: 0,
                fontSize: '0.875rem',
                lineHeight: 1.5,
              },
              '& .MuiTablePagination-select': {
                paddingTop: '4px',
                paddingBottom: '4px',
                fontSize: '0.875rem',
                minHeight: 'unset',
              },
              '& .MuiTablePagination-selectIcon': {
                top: 'calc(50% - 0.5em)',
              },
            }}
          >
            <DataGrid
              getRowId={(r) => r.SaleOrderId}
              rows={dataFilter}
              columns={columns}
              paginationMode="server"
              rowCount={rowCount}
              page={page}
              onPageChange={(newPage) => setPage(newPage)}
              pageSize={pageSize}
              onPageSizeChange={(newSize) => setPageSize(newSize)}
              rowsPerPageOptions={[10, 25, 50, 100]}
              loading={gridLoading}
              hideFooterSelectedRowCount
              disableColumnFilter
              disableColumnMenu
              getCellClassName={(params) => {
                if (params.field === "Status") {
                  return params.value == 1
                    ? "New"
                    : params.value == 2
                      ? "Process"
                      : params.value == 3
                        ? "AssignToPlanner"
                        : params.value == 4
                          ? "AssignToCy"
                          : params.value == 5
                            ? "Confirm"
                            : params.value == 6
                              ? "AssignToDocument"
                              : params.value == 7
                                ? "AssignToAdmin"
                                : params.value == 8
                                  ? "Complete"
                                  : "Cancel";
                }
              }}
            // components={{
            //   Toolbar: CustomToolbar,
            // }}
            />
          </Box>
        </Card>
        {MenuActive.find((x) => x.ActionNo === "A016") && (
          <Link to="/CustomerSupport/AddSaleOrder">
            <Fab color="primary" style={floating_action_style} aria-label="add">
              <AddIcon />
            </Fab>
          </Link>
        )}
      </LocalizationProvider>
    </div>
  );
}
